module.exports = __webpack_public_path__ + "media/images/new_entry_free_sp-358f378d024f61150f287115d387d1c4.png";